var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-dropdown"},[_c('div',{staticClass:"v-dropdown__base",on:{"click":_vm.handleShow}},[_vm._t("base",null,{"handleShow":_vm.handleShow})],2),(_vm.show)?_c('div',{staticClass:"v-dropdown__area"},[_vm._t("dropdown",null,{"handleShow":_vm.handleShow})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }